import React from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Container,
  Button,
  Card,
  CardContent,
  Divider
} from '@mui/material';
import { 
  CheckCircle as CheckCircleIcon,
  Email as EmailIcon
} from '@mui/icons-material';
import { useParams } from 'react-router-dom';

const ThankYouPage = () => {
  const { token } = useParams();

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Card elevation={3}>
        <CardContent sx={{ p: 4, textAlign: 'center' }}>
          <CheckCircleIcon color="success" sx={{ fontSize: 64, mb: 2 }} />
          
          <Typography variant="h4" component="h1" gutterBottom>
            Thank You for Your Submission
          </Typography>
          
          <Typography variant="body1" paragraph>
            Your questionnaire responses and documents have been successfully submitted.
          </Typography>
          
          <Typography variant="body1" paragraph>
            Our team will review your submission and may contact you if additional information is needed.
          </Typography>
          
          <Divider sx={{ my: 3 }} />
          
          <Typography variant="h6" gutterBottom>
            What Happens Next?
          </Typography>
          
          <Box sx={{ textAlign: 'left', maxWidth: 500, mx: 'auto', mb: 3 }}>
            <Typography variant="body1" paragraph>
              1. Our review team will assess your submission
            </Typography>
            <Typography variant="body1" paragraph>
              2. You may be contacted for additional information if needed
            </Typography>
            <Typography variant="body1" paragraph>
              3. A final report will be prepared and shared with you
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            If you have any questions, please contact your audit manager.
          </Typography>
          
          <Button
            variant="contained"
            color="primary"
            startIcon={<EmailIcon />}
            sx={{ mt: 3 }}
            onClick={() => window.location.href = "mailto:support@auditmanagement.com"}
          >
            Contact Support
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};

export default ThankYouPage;
